import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="K" transform="translate(11.000000, 5.000000)">
        <path
          d="M31,61 L31,30 L36.5,30 L36.5,43 L46,30 L52.5,30 L43.5,42.5 L53,61 L46.5,61 L39.5,47 L36.5,50.5 L36.5,61 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
